module.exports = __webpack_public_path__ + "static/media/empty-applications.56560ef4.svg";